// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__vhgd_","range":"MonthRangeSwitch_range__1rzca","disabled":"MonthRangeSwitch_disabled__3Sp4e"};